export const INTEGRATION_PERMISSION_PREFIX = 'integration:';

export const integrationPermissionId = (entitlementKey: string): string =>
  `${INTEGRATION_PERMISSION_PREFIX}${entitlementKey}`;

export const isIntegrationPermissionId = (id: string): boolean =>
  id.startsWith(INTEGRATION_PERMISSION_PREFIX);

export const entitlementKeyFromPermissionId = (id: string): string | null =>
  isIntegrationPermissionId(id) ? id.slice(INTEGRATION_PERMISSION_PREFIX.length) : null;

export interface IntegrationPermissionInput {
  menu_permissions: string[] | null | undefined;
  entitlementKey: string;
}

export const isIntegrationGrantedByPermissions = ({
  menu_permissions,
  entitlementKey,
}: IntegrationPermissionInput): boolean => {
  if (!Array.isArray(menu_permissions)) return true;
  const hasExplicitIntegrationKeys = menu_permissions.some(isIntegrationPermissionId);
  if (!hasExplicitIntegrationKeys) return true;
  return menu_permissions.includes(integrationPermissionId(entitlementKey));
};
